import React from 'react'
import { styled, FloraVariants, forwardRef } from '@grupoboticario/flora-react-system'
import { HTMLFloraProps } from '@grupoboticario/flora-react-utils'

const StyledTableRow = styled('tr', {
  height: '$12',
  '&:first-of-type': {
    height: '$8',
  },
})

export type TableRowProps = HTMLFloraProps<'tr'> & FloraVariants<typeof StyledTableRow>

export const TableRow = forwardRef<'tr', TableRowProps>((props, forwardedRef) => {
  return <StyledTableRow ref={forwardedRef} data-flora="table-row" {...props} />
})
